
  
  var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
  var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
  var var_l_sph = ''; //Este es el valor del SPH en el ojo izquierdo
  var var_r_sph = ''; //Este es el valor del SPH en el ojo derecho
  
$('#left-poder-sph').click(function() {
    var_l_sph = $('#4634218070087_option_4').val();
  console.log(var_l_sph); 
  unify_values_l();
  fetch_sku_l();
});


$('#right-poder-sph').click(function() {
    var_r_sph = $('#4634218070087_option_5').val();
  console.log(var_r_sph); 
  unify_values_r();
  fetch_sku_r();
});


function unify_values_l(){
  sku_values_l = var_l_sph ;
  console.log(sku_values_l);
}

function unify_values_r(){
  sku_values_r = var_r_sph;
  console.log(sku_values_r);
}

function check_express() {
  // Parsear exceptions a un array limpio
  const exceptions = (window.ShopifyLc?.exceptions || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

  // Revisar si cada ojo está en exceptions (equivale a)
  const l_blocked = sku_values_l ? exceptions.includes(sku_values_l.trim()) : null;
  const r_blocked = sku_values_r ? exceptions.includes(sku_values_r.trim()) : null;

  if ($('#switch1').is(':checked')) {
    // Ambos ojos seleccionados
    if (l_blocked === null && r_blocked === null) {
      // Ninguno seleccionado aún
      $('.lc-express-container, .lc-nostock-container, .lc-step-3, .lc-step-2').hide();
    } else if (l_blocked || r_blocked) {
      // Al menos uno está en exceptions → no disponible
      $('.lc-nostock-container').css('display', 'inline-block');
      $('.lc-express-container').hide();
      $('.lc-step-3, .lc-step-2').hide();
    } else {
      // Ambos disponibles
      $('.lc-express-container').css('display', 'inline-block');
      $('.lc-nostock-container').hide();
      $('.lc-step-3, .lc-step-2').show();
    }
  } else {
    // Solo ojo izquierdo
    if (l_blocked === null) {
      // No seleccionado aún
      $('.lc-express-container, .lc-nostock-container, .lc-step-3, .lc-step-2').hide();
    } else if (l_blocked) {
      // Está en exceptions → no disponible
      $('.lc-nostock-container').css('display', 'inline-block');
      $('.lc-step-3, .lc-step-2').hide();
      $('.lc-express-container').hide();
    } else {
      // Disponible
      $('.lc-express-container').css('display', 'inline-block');
      $('.lc-step-3, .lc-step-2').show();
      $('.lc-nostock-container').hide();
    }
  }
}

$('#switch1').change(function() { check_express(); });

function fetch_sku_l(){
  switch (sku_values_l) {

case '-0.50' :  check_express(); break;
case '-0.75' :  check_express(); break;
case '-1.00' :  check_express(); break;
case '-1.25' :  check_express(); break;
case '-1.50' :  check_express(); break;
case '-1.75' :  check_express(); break;
case '-2.00' :  check_express(); break;
case '-2.25' :  check_express(); break;
case '-2.50' :  check_express(); break;
case '-2.75' :  check_express(); break;
case '-3.00' :  check_express(); break;
case '-3.25' :  check_express(); break;
case '-3.50' :  check_express(); break;
case '-3.75' :  check_express(); break;
case '-4.00' :  check_express(); break;
case '-4.25' :  check_express(); break;
case '-4.50' :  check_express(); break;
case '-4.75' :  check_express(); break;
case '-5.00' :  check_express(); break;
case '-5.25' :  check_express(); break; 
case '-5.50' :  check_express(); break;
case '-5.75' :  check_express(); break;  
case '-6.00' :  check_express(); break;
case '-6.50' :  check_express(); break; 
case '-7.00' :  check_express(); break; 
case '-7.50' :  check_express(); break; 
case '-8.00' :  check_express(); break; 
case '-8.50' :  check_express(); break; 
case '-9.00' :  check_express(); break; 
case '-9.50' :  check_express(); break; 
case '-10.00' :  check_express(); break; 
case '-10.50' :  check_express(); break; 
case '-11.00' :  check_express(); break; 
case '-11.50' :  check_express(); break; 
case '-12.00' :  check_express(); break;
case '+0.50' :  check_express(); break; 
case '+0.75' :  check_express(); break; 
case '+1.00' :  check_express(); break; 
case '+1.25' :  check_express(); break; 
case '+1.50' :  check_express(); break; 
case '+1.75' :  check_express(); break; 
case '+2.00' :  check_express(); break; 
case '+2.25' :  check_express(); break; 
case '+2.50' :  check_express(); break; 
case '+2.75' :  check_express(); break; 
case '+3.00' :  check_express(); break; 
case '+3.25' :  check_express(); break; 
case '+3.50' :  check_express(); break; 
case '+3.75' :  check_express(); break; 
case '+4.00' :  check_express(); break; 
case '+4.25' :  check_express(); break; 
case '+4.50' :  check_express(); break; 
case '+4.75' :  check_express(); break; 
case '+5.00' :  check_express(); break; 
case '+5.25' :  check_express(); break; 
case '+5.50' :  check_express(); break; 
case '+5.75' :  check_express(); break; 
case '+6.00' :  check_express(); break; 
case '+6.50' :  check_express(); break; 
case '+7.00' :  check_express(); break; 
case '+7.50' :  check_express(); break; 
case '+8.00' :  check_express(); break; 

}

    
}//fetch_sku()



function fetch_sku_r(){
  switch (sku_values_r) {

case '-0.50' :  check_express(); break;
case '-0.75' :  check_express(); break;
case '-1.00' :  check_express(); break;
case '-1.25' :  check_express(); break;
case '-1.50' :  check_express(); break;
case '-1.75' :  check_express(); break;
case '-2.00' :  check_express(); break;
case '-2.25' :  check_express(); break;
case '-2.50' :  check_express(); break;
case '-2.75' :  check_express(); break;
case '-3.00' :  check_express(); break;
case '-3.25' :  check_express(); break;
case '-3.50' :  check_express(); break;
case '-3.75' :  check_express(); break;
case '-4.00' :  check_express(); break;
case '-4.25' :  check_express(); break;
case '-4.50' :  check_express(); break;
case '-4.75' :  check_express(); break;
case '-5.00' :  check_express(); break;
case '-5.25' :  check_express(); break; 
case '-5.50' :  check_express(); break;
case '-5.75' :  check_express(); break;  
case '-6.00' :  check_express(); break;
case '-6.50' :  check_express(); break; 
case '-7.00' :  check_express(); break; 
case '-7.50' :  check_express(); break; 
case '-8.00' :  check_express(); break; 
case '-8.50' :  check_express(); break; 
case '-9.00' :  check_express(); break; 
case '-9.50' :  check_express(); break; 
case '-10.00' :  check_express(); break; 
case '-10.50' :  check_express(); break; 
case '-11.00' :  check_express(); break; 
case '-11.50' :  check_express(); break; 
case '-12.00' :  check_express(); break;
case '+0.50' :  check_express(); break; 
case '+0.75' :  check_express(); break; 
case '+1.00' :  check_express(); break; 
case '+1.25' :  check_express(); break; 
case '+1.50' :  check_express(); break; 
case '+1.75' :  check_express(); break; 
case '+2.00' :  check_express(); break; 
case '+2.25' :  check_express(); break; 
case '+2.50' :  check_express(); break; 
case '+2.75' :  check_express(); break; 
case '+3.00' :  check_express(); break; 
case '+3.25' :  check_express(); break; 
case '+3.50' :  check_express(); break; 
case '+3.75' :  check_express(); break; 
case '+4.00' :  check_express(); break; 
case '+4.25' :  check_express(); break; 
case '+4.50' :  check_express(); break; 
case '+4.75' :  check_express(); break; 
case '+5.00' :  check_express(); break; 
case '+5.25' :  check_express(); break; 
case '+5.50' :  check_express(); break; 
case '+5.75' :  check_express(); break; 
case '+6.00' :  check_express(); break; 
case '+6.50' :  check_express(); break; 
case '+7.00' :  check_express(); break; 
case '+7.50' :  check_express(); break; 
case '+8.00' :  check_express(); break;  

}


}//fetch_sku()